
import { feedServer } from '@/http';

export default {
    // Define your actions here
    async fetchPhotos(context, payload) {
        const response = await feedServer.get(`${payload.userId}/photos`, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        });
        const photos = await response.data;
        if (!response.status === 200) {
            const error = new Error(response.data.message || 'Failed to fetch photos.');
            throw error;
        }

        context.commit('setPhotos', photos);

        return photos;
    }
};